
import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { MARKET_TYPES, LOCATION_OPTIONS } from '../constants';

interface MarketTypeLocationFieldsProps {
  marketType: string;
  location: string;
  onMarketTypeChange: (value: string) => void;
  onLocationChange: (value: string) => void;
}

export const MarketTypeLocationFields: React.FC<MarketTypeLocationFieldsProps> = ({
  marketType,
  location,
  onMarketTypeChange,
  onLocationChange
}) => {
  const getAvailableLocations = () => {
    if (!marketType) return [];
    return LOCATION_OPTIONS[marketType as keyof typeof LOCATION_OPTIONS] || [];
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Market Type Selection */}
      <div className="space-y-2">
        <Label htmlFor="marketType">Market Type *</Label>
        <Select value={marketType} onValueChange={onMarketTypeChange}>
          <SelectTrigger>
            <SelectValue placeholder="Select market type" />
          </SelectTrigger>
          <SelectContent>
            {MARKET_TYPES.map((type) => (
              <SelectItem key={type.value} value={type.value}>
                {type.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {/* Location */}
      <div className="space-y-2">
        <Label htmlFor="location">Location *</Label>
        <Select 
          value={location} 
          onValueChange={onLocationChange}
          disabled={!marketType}
        >
          <SelectTrigger>
            <SelectValue placeholder={marketType ? "Select location" : "Select market type first"} />
          </SelectTrigger>
          <SelectContent>
            {getAvailableLocations().map((location) => (
              <SelectItem key={location} value={location}>
                {location}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
